import React from 'react';

import SlideElement from "../slide-element/slide-element";

import './project-slider.scss';

import beeline_ds from '../../f/img/slider/beeline-ds.png';
import beeline_site from '../../f/img/slider/beeline-site.png';
import beeline_identity from '../../f/img/slider/beeline-id.png';
import kriv_site from '../../f/img/slider/kriv-site.png';
import kriv_logo from '../../f/img/slider/kriv-logo.png';
import pegas_site from '../../f/img/slider/agro-site.png';
import pegas_prom from '../../f/img/slider/agro-int.png';
import lavrus_promo from '../../f/img/slider/lavrus-promo.png';
import lavrus_logo from '../../f/img/slider/lavrus-strat.png';
import lavrus_site from '../../f/img/slider/lavrus-site.png';
import umbrella_logo from '../../f/img/slider/uit-id.png';
import umbrella_site from '../../f/img/slider/uit-site.png';



const ProjectSlider = () => {
  const slider = React.useRef();
  const buttons = React.useRef();

  const handleButtonClick = event => {
    const target = event.target;

    if (target.classList.contains('selected')) {
      return;
    }

    const id = target.dataset.id;
    const container = slider.current;
    const buttonEls = Array.from(buttons.current.children);

    buttonEls.forEach((el) => {
      el.classList.remove('selected');
    });

    target.classList.add('selected');

    container.style = 'transform:translateX(-' + (100 * id) +'vw);';
  };

  return (
      <React.Fragment>
        <div className="slider">
          <h2 className="slider__header">
            Все необходимое сразу
          </h2>

          <div ref={buttons} className="slider__buttons">
            <div data-id="0" onClick={handleButtonClick} className="slider__button selected">
              Билайн
            </div>
            <div data-id="1" onClick={handleButtonClick} className="slider__button">
              Кривицкий
            </div>
            <div data-id="2" onClick={handleButtonClick} className="slider__button">
              Пегас-агро
            </div>
            <div data-id="3" onClick={handleButtonClick} className="slider__button">
              Лаврус
            </div>
            <div data-id="4" onClick={handleButtonClick} className="slider__button">
              Абмрелла Ай-ти
            </div>
          </div>
          <div ref={slider} className="slider__container">
            <div className="slide">
              <div className="slide__content">
                <SlideElement
                    href="https://www.artlebedev.ru/beeline/design-system/"
                    content={beeline_ds}
                    description="Дизайн-система"
                />
                <SlideElement
                    href="https://www.artlebedev.ru/beeline/site2/"
                    content={beeline_site}
                    description="Сайт"
                />
                <SlideElement
                    href="https://www.artlebedev.ru/beeline/interface/"
                    content={beeline_identity}
                    description="Айдентика игровой приставки"
                />
              </div>
            </div>
            <div className="slide">
              <div className="slide__content">
                <SlideElement
                  href="https://www.artlebedev.ru/krivitzky/logo/"
                  content={kriv_logo}
                  description="Дизайн логотипа"
                  short="Логотип"
                />
                <SlideElement
                    href="https://www.artlebedev.ru/krivitzky/site/"
                    content={kriv_site}
                    description="Дизайн сайта"
                    short="Сайт"
                />
              </div>
            </div>
            <div className="slide">
              <div className="slide__content">
                <SlideElement
                    href="https://www.artlebedev.ru/pegas-agro/machine/"
                    content={pegas_prom}
                    description="Промдизайн машины"
                />
                <SlideElement
                    href="https://www.artlebedev.ru/pegas-agro/site/"
                    content={pegas_site}
                    description="Дизайн сайта"
                    short="Сайт"
                />
              </div>
            </div>
            <div className="slide">
              <div className="slide__content">
                <SlideElement
                    href="https://www.artlebedev.ru/tretyakovgallery/lavrus-identity/"
                    content={lavrus_logo}
                    description="Бренд-стратегия, нейминг, логотип"
                    short="Стратегия"
                />
                <SlideElement
                    href="https://www.artlebedev.ru/tretyakovgallery/lavrus-site/"
                    content={lavrus_site}
                    description="Дизайн сайта"
                    short="Сайт"
                />
                <SlideElement
                    href="https://www.artlebedev.ru/tretyakovgallery/lavrus-ad/"
                    content={lavrus_promo}
                    description="Промо-ролик"
                />
              </div>
            </div>
            <div className="slide">
              <div className="slide__content">
                <SlideElement
                    href="https://www.artlebedev.ru/umbrellaitcom/identity/"
                    content={umbrella_logo}
                    description="Разработка айдентики"
                    short="Айдентика"
                />
                <SlideElement
                    href="https://www.artlebedev.ru/umbrellaitcom/site/"
                    content={umbrella_site}
                    description="Дизайн сайта"
                    short="Сайт"
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
  );
}

export default ProjectSlider;
